import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LocalStorageService } from 'src/app/core/services/localStorage/local-storage.service';
import { ProfileService } from 'src/app/core/services/profile/profile.service';
import { UtilService } from 'src/app/core/services/util.service';
import { InputControlMessagesComponent } from 'src/app/core/validations/Input-control-messages.component';
import { InputControls } from 'src/app/core/validations/InputControls';
import { ValidationService } from 'src/app/core/validations/ValidationService';
import { MaterialModule } from 'src/app/material.module';
import { ToastService } from 'src/app/shared/services/toast.service';
import { oldNewPasswordValidator } from './old-new-password-validation';

@Component({
  selector: 'app-update-password',
  imports: [MaterialModule, ReactiveFormsModule, InputControlMessagesComponent],
  templateUrl: './update-password.component.html',
  styleUrl: './update-password.component.scss'
})
export class UpdatePasswordComponent {
  updatePasswordForm: FormGroup;
  userId: any;
  inputControls: any = InputControls;
  isShowPassword: boolean = false;
  isShowNewPassword: boolean = false;

  constructor(
    private fb: FormBuilder,
    private utilService: UtilService,
    private toastService: ToastService,
    private profileService: ProfileService,
    private localStorageService: LocalStorageService,
    public dialogRef: MatDialogRef<UpdatePasswordComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any
  ) {
    this.userId = this.localStorageService.getUserId();
  }

  ngOnInit(): void {
    this.initForm();
  }

  showHidePassword() {
    this.isShowPassword = !this.isShowPassword;
  }

  showHideNewPassword() {
    this.isShowNewPassword = !this.isShowNewPassword;
  }

  initForm() {
  this.updatePasswordForm = this.fb.group({
    oldPassword: ['', [ValidationService.required]],
    newPassword: ['', [ValidationService.required, ValidationService.strongPassword]],
  }, { validators: oldNewPasswordValidator() })
}

  updatePassword() {

    if (this.updatePasswordForm.invalid) {
      return this.utilService.validateAllFormFields(this.updatePasswordForm);
    }

    const formValue = this.updatePasswordForm.value;
    const body = {
      password: formValue.oldPassword,
      newPassword: formValue.newPassword
    }

    this.profileService.updatePasswordByUserId(this.userId, body).subscribe({
      next: (res: any) => {
        if (res.isSuccess) {
          this.dialogRef.close();
          this.toastService.successToast(res.message);
        }
      },
      error: () => { }
    })
  }
}
